var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var MSelect = function () {
            function MSelect() {
                _classCallCheck(this, MSelect);

                this.mSelect = null;
                this.mSelectToggle = null;
                this.mSelectInput = null;
                this.mSelectOptions = null;
                this.mode = '';
                this.modalConfig = {};
                this.modalContentId = '';
                this.modalTitle = null;

                this.handlers();
            }

            _createClass(MSelect, [{
                key: "handlers",
                value: function handlers() {
                    var _this = this;

                    eventDispatcher.on('click', '.js-open-select-modal', function (event, targetElement) {
                        _this.modalContentId = targetElement.dataset.contentId;
                        _this.modalTitle = targetElement.dataset.title;
                        _this.mSelect = targetElement.closest('.m-select');
                        _this.mSelectToggle = _this.mSelect.querySelector('.m-select__toggle');
                        _this.mSelectInput = _this.mSelect.querySelector('.m-select__input');
                        _this.mSelectOptions = _this.mSelect.querySelector('#' + _this.modalContentId);
                        _this.mode = _this.mSelect.dataset.mode;

                        _this.openSelectModal();
                    });

                    eventDispatcher.on('click', '.js-m-select-item-value', function (event, targetElement) {
                        var selector = '.js-open-select-modal[data-content-id="' + _this.modalContentId + '"]';
                        var element = document.querySelector(selector);
                        var parent = targetElement.closest('.m-select__option');

                        if (_this.mode !== 'multiple') {
                            var mSelect = element.closest('.m-select');
                            eventDispatcher.dispatchEvent('_m-select-change-value', {
                                value: targetElement.value,
                                name: parent.querySelector('.m-select__option-label').innerHTML,
                                mSelectElement: mSelect,
                                type: element.closest('.m-select').dataset.type
                            });

                            window.modal.close("." + _this.parentCssClass);
                        }
                    });

                    eventDispatcher.addEventListener('_m-select-change-value', function (data) {
                        _this.setMSelectToggleLabel(data);
                        _this.setMSelectValue(data);

                        data.mSelectElement.querySelector('input').dispatchEvent(new Event('change', { bubbles: true }));

                        var resetSelect = data.mSelectElement.querySelector('.reset-select');
                        if (resetSelect) {
                            if (data.value === '') {
                                resetSelect.classList.add('hidden');
                            } else {
                                resetSelect.classList.remove('hidden');
                            }
                        }
                    });

                    eventDispatcher.on('click', '.reset-select', function (event, element) {
                        var select = element.closest('.m-select');
                        eventDispatcher.dispatchEvent('_m-select-change-value', {
                            value: '',
                            name: select.querySelector('.m-select__option-label').textContent,
                            mSelectElement: select,
                            type: select.dataset.type
                        });
                    });

                    eventDispatcher.on('click', '.m-select-apply', function (event, targetElement) {
                        var selector = '.js-open-select-modal[data-content-id="' + _this.modalContentId + '"]';
                        var element = document.querySelector(selector);

                        var value = [];
                        var names = [];
                        _this.mSelectOptions.querySelectorAll('.m-select-item-value:checked').forEach(function (item) {
                            var parent = item.closest('.m-select__option');
                            value.push(item.value);
                            names.push(parent.querySelector('.m-select__option-label').innerHTML);
                        });

                        eventDispatcher.dispatchEvent('_m-select-change-value', {
                            value: value,
                            name: names,
                            mSelectElement: element.closest('.m-select')
                        });
                    });

                    eventDispatcher.on('input', '.search-by-m-select-options .search-input', function (event, targetElement) {
                        var text = targetElement.value.trim().toLowerCase();
                        var content = targetElement.closest('.m-select__content');
                        var options = content.querySelectorAll('.m-select__option');

                        var notFound = content.querySelector('.m-select__not-found');
                        if (!notFound) {
                            notFound = document.createElement('div');
                            notFound.className = 'm-select__not-found hidden';
                            notFound.textContent = 'Ничего не найдено';
                            content.appendChild(notFound);
                        }

                        var visibleCount = 0;

                        options.forEach(function (option) {
                            // пропускаем уже скрытые внешними фильтрами
                            if (option.classList.contains('hidden')) return;

                            var label = option.querySelector('.m-select__option-label');
                            var original = label.dataset.original || label.textContent.trim();

                            if (!label.dataset.original) {
                                label.dataset.original = original;
                            }

                            var labelText = original.toLowerCase();

                            if (text === '' || labelText.includes(text)) {
                                option.classList.remove('search-hidden'); // показываем
                            } else {
                                option.classList.add('search-hidden'); // скрываем
                            }

                            if (text === '') {
                                option.classList.remove('search-hidden');
                                label.innerHTML = original;
                                visibleCount++;
                                return;
                            }

                            // совпадение?
                            if (labelText.includes(text)) {
                                option.classList.remove('search-hidden');
                                visibleCount++;

                                // подсветка
                                var start = labelText.indexOf(text);
                                var end = start + text.length;

                                label.innerHTML = original.substring(0, start) + ("<span class=\"highlight\">" + original.substring(start, end) + "</span>") + original.substring(end);
                            } else {
                                option.classList.add('search-hidden');
                                label.innerHTML = original;
                            }
                        });

                        if (visibleCount === 0) {
                            notFound.classList.remove('hidden');
                        } else {
                            notFound.classList.add('hidden');
                        }
                    });
                }
            }, {
                key: "openSelectModal",
                value: function openSelectModal() {
                    var _this2 = this;

                    this.parentCssClass = 'm-select-modal';

                    if (this.mSelectOptions.querySelector('.search-by-m-select-options')) {
                        this.parentCssClass = 'm-select-modal-full-height';
                    }
                    this.modalConfig = {
                        animationDuration: 100,
                        content: {
                            htmlDetachSelectorId: this.modalContentId
                        },
                        parentCssClass: this.parentCssClass,
                        footer: null,
                        onAfterShow: function onAfterShow() {
                            _this2.markAsCheck(_this2.mSelectInput.value);
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this2.markAsUncheck();
                            _this2.clearSearch();
                        }
                    };

                    if (this.modalTitle) {
                        this.modalConfig.header = {
                            title: this.modalTitle
                        };
                    }

                    if (this.mode === 'multiple') {
                        this.modalConfig.footer = {
                            buttonLabel: 'Применить',
                            buttonCssClass: 'm-select-apply'
                        };
                    }

                    window.modal.open(this.modalConfig);
                }
            }, {
                key: "markAsCheck",
                value: function markAsCheck(selectedValue) {
                    var selectedValues = selectedValue.split(',');

                    this.mSelectOptions.querySelectorAll('.m-select-item-value').forEach(function (item) {
                        if (selectedValues.includes(item.value)) {
                            item.checked = true;
                        }
                    });
                }
            }, {
                key: "markAsUncheck",
                value: function markAsUncheck() {
                    this.mSelectOptions.querySelectorAll('.m-select-item-value').forEach(function (item) {
                        item.checked = false;
                    });
                }
            }, {
                key: "setMSelectToggleLabel",
                value: function setMSelectToggleLabel(data) {
                    var mSelect = data.mSelectElement;
                    var name = data.name;

                    if (this.mode === 'multiple') {
                        var count = data.value.length;

                        if (count > 1) {
                            var _window;

                            var plural = (_window = window).plural.apply(_window, [data.value.length].concat(_toConsumableArray(this.mSelectToggle.dataset.plural.split(','))));
                            name = "\u0412\u044B\u0431\u0440\u0430\u043D\u043E " + count + " " + plural;
                        } else {
                            name = data.name;
                        }
                    }

                    mSelect.querySelector('.js-open-select-modal').innerHTML = name;
                }
            }, {
                key: "setMSelectValue",
                value: function setMSelectValue(data) {
                    var mSelect = data.mSelectElement;

                    mSelect.querySelector('input.m-select__input').value = data.value;
                }
            }, {
                key: "clearSearch",
                value: function clearSearch() {

                    var input = this.mSelectOptions.querySelector('.search-by-m-select-options .search-input');
                    if (!input) return;

                    input.value = '';

                    var content = input.closest('.m-select__content');
                    var options = content.querySelectorAll('.m-select__option');

                    options.forEach(function (option) {
                        option.classList.remove('search-hidden');

                        var label = option.querySelector('.m-select__option-label');
                        if (label && label.dataset.original) {
                            label.innerHTML = label.dataset.original;
                        }
                    });

                    var notFound = content.querySelector('.m-select__not-found');
                    if (notFound) {
                        notFound.classList.add('hidden');
                    }
                }
            }]);

            return MSelect;
        }();

        window.MSelect = MSelect;
    }, {}] }, {}, [1]);